module.exports = __webpack_public_path__ + "img/loader_excluded_264x264.6375b4a5.gif";